/* eslint-disable */
import { config } from 'config';

export const initAppNexus = () => {
  $(function () {
    CBM.appNexus = new CBM.AppNexus({
      siteID: config.APPNEXUS_SITE_ID,
      siteName: config.APPNEXUS_SITE_NAME,
      divSelector: 'data-pub-appnexus',
      deviceType: '',
      kValues: {},
      pageLabel: 'Pro-RG',
      deviceTypes: {
        tablet: 'tab',
        desktop: 'desk',
      },
      sizesByFormat: {
        Pave: [[300, 250]],
      },
      pageFormats: {
        tablet: {
          'Pro-RG': ['Pave'],
        },
        desktop: {
          'Pro-RG': ['Pave'],
        }
      }
    });
  });
};
